// Filter Drawer - AJAX Implementation (No Page Reload)

class FilterDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.drawer = this;
    this.panel = this.querySelector('.filter-drawer__panel');
    this.overlay = this.querySelector('.filter-drawer__overlay');
    this.closeButton = this.querySelector('.filter-drawer__close');
    this.form = this.querySelector('.filter-drawer__form');
    this.clearButton = this.querySelector('.filter-drawer__button--clear');
    this.applyButton = this.querySelector('.filter-drawer__button--apply');
    this.sectionId = this.dataset.sectionId;
    this.isLoading = false;

    this.setupEventListeners();
    this.setupAccordions();
  }

  setupEventListeners() {
    // Prevent ALL form submissions
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);

      this.form.onsubmit = function() {
        return false;
      };
    }

    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
        document.getElementById('shopify-chat').style.removeProperty('z-index');
      });
    }

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
        document.getElementById('shopify-chat').style.removeProperty('z-index');
      });
    }

    // Clear filters
    if (this.clearButton) {
      this.clearButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.clearFilters();
        return false;
      });
    }

    // Apply filters
    if (this.applyButton) {
      this.applyButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.applyFilters();
        return false;
      }, true);

      this.applyButton.onclick = (e) => {
        e.preventDefault();
        this.applyFilters();
        return false;
      };
    }

    // Escape key to close
    this.escapeHandler = (e) => {
      if (e.key === 'Escape' && this.classList.contains('active')) {
        this.close();
        document.getElementById('shopify-chat').style.removeProperty('z-index');
      }
    };
    document.addEventListener('keydown', this.escapeHandler);
  }

  setupAccordions() {
    const accordions = this.querySelectorAll('.filter-drawer__group');
    accordions.forEach(accordion => {
      const summary = accordion.querySelector('.filter-drawer__group-summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          // Let native details/summary behavior work
        });
      }
    });
  }

  open() {
    this.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.getElementById('shopify-chat').style.zIndex = '-1';
    setTimeout(() => {
      this.trapFocus();
    }, 100);
  }

  close() {
    this.classList.remove('active');
    document.body.style.overflow = '';
    document.getElementById('shopify-chat').style.removeProperty('z-index');

    const trigger = document.querySelector('.filter-drawer-trigger');
    if (trigger) {
      trigger.focus();
    }
  }

  clearFilters() {
    if (this.isLoading) return;

    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]:checked');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    const priceInputs = this.form.querySelectorAll('.filter-drawer__price-input');
    priceInputs.forEach(input => {
      input.value = '';
    });

    this.applyFilters();
  }

  applyFilters() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.showLoading();

    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(window.location.search);

    // Clear existing filter params
    const filterParams = [];
    for (let [key] of formData.entries()) {
      filterParams.push(key);
    }

    const keysToDelete = [];
    for (let [key] of searchParams.entries()) {
      if (key.startsWith('filter.') || key === 'sort_by') {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => searchParams.delete(key));

    // Add new filter params
    for (let [key, value] of formData.entries()) {
      if (value) {
        searchParams.append(key, value);
      }
    }

    // Preserve sort order from drawer
    const sortSelect = document.querySelector('#SortBy-drawer');
    if (sortSelect && sortSelect.value) {
      searchParams.set('sort_by', sortSelect.value);
    }

    // Build URL
    const queryString = searchParams.toString();
    const url = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;

    // Update browser URL without reload
    window.history.pushState({ path: url }, '', url);

    // Fetch filtered results
    this.fetchFilteredResults(url);
  }

  async fetchFilteredResults(url) {
    try {
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      this.updateProductGrid(doc);
      this.updateFilterCounts(doc);
      this.updateActiveFilterCount();
      this.close();
      document.getElementById('shopify-chat').style.removeProperty('z-index');
      // this.scrollToProducts();
    } catch (error) {
      console.error('Error fetching filtered results:', error);
      window.location.href = url;
    } finally {
      this.isLoading = false;
      this.hideLoading();
    }
  }

  updateProductGrid(doc) {
    const newProductGrid = doc.querySelector('#product-grid, .product-grid, [id*="product-grid"]');
    const currentProductGrid = document.querySelector('#product-grid, .product-grid, [id*="product-grid"]');

    if (newProductGrid && currentProductGrid) {
      currentProductGrid.style.opacity = '0.5';
      currentProductGrid.style.transition = 'opacity 0.3s ease';

      setTimeout(() => {
        currentProductGrid.innerHTML = newProductGrid.innerHTML;
        currentProductGrid.style.opacity = '1';
        this.reinitializeProductCards();
      }, 300);
    }

    const newPagination = doc.querySelector('.pagination, [class*="pagination"]');
    const currentPagination = document.querySelector('.pagination, [class*="pagination"]');

    if (newPagination && currentPagination) {
      currentPagination.innerHTML = newPagination.innerHTML;
    }

    const newProductCount = doc.querySelector('.product-count, [class*="product-count"]');
    const currentProductCount = document.querySelector('.product-count, [class*="product-count"]');

    if (newProductCount && currentProductCount) {
      currentProductCount.innerHTML = newProductCount.innerHTML;
    }
  }

  updateFilterCounts(doc) {
    const newFilterGroups = doc.querySelectorAll('.filter-drawer__group');
    const currentFilterGroups = this.querySelectorAll('.filter-drawer__group');

    newFilterGroups.forEach((newGroup, index) => {
      const currentGroup = currentFilterGroups[index];
      if (!currentGroup) return;

      const newCheckboxes = newGroup.querySelectorAll('.filter-drawer__checkbox-label');
      const currentCheckboxes = currentGroup.querySelectorAll('.filter-drawer__checkbox-label');

      newCheckboxes.forEach((newCheckbox, checkboxIndex) => {
        const currentCheckbox = currentCheckboxes[checkboxIndex];
        if (!currentCheckbox) return;

        const newCount = newCheckbox.querySelector('.filter-drawer__checkbox-count');
        const currentCount = currentCheckbox.querySelector('.filter-drawer__checkbox-count');

        if (newCount && currentCount) {
          currentCount.textContent = newCount.textContent;
        }

        const newInput = newCheckbox.querySelector('input');
        const currentInput = currentCheckbox.querySelector('input');

        if (newInput && currentInput) {
          if (newInput.disabled) {
            currentCheckbox.classList.add('disabled');
            currentInput.disabled = true;
          } else {
            currentCheckbox.classList.remove('disabled');
            currentInput.disabled = false;
          }
        }
      });
    });
  }

  updateActiveFilterCount() {
    const checkedFilters = this.form.querySelectorAll('input[type="checkbox"]:checked');
    const priceInputs = this.form.querySelectorAll('.filter-drawer__price-input');
    let priceFilterActive = false;

    priceInputs.forEach(input => {
      if (input.value) priceFilterActive = true;
    });

    const totalActive = checkedFilters.length + (priceFilterActive ? 1 : 0);
    const trigger = document.querySelector('.filter-drawer-trigger');
    if (!trigger) return;

    let countBadge = trigger.querySelector('.filter-drawer-trigger__count');

    if (totalActive > 0) {
      if (!countBadge) {
        countBadge = document.createElement('span');
        countBadge.className = 'filter-drawer-trigger__count';
        trigger.appendChild(countBadge);
      }
      countBadge.textContent = `(${totalActive})`;
    } else {
      if (countBadge) {
        countBadge.remove();
      }
    }
  }

  reinitializeProductCards() {
    if (typeof window.initializeQuickAdd === 'function') {
      window.initializeQuickAdd();
    }

    document.dispatchEvent(new CustomEvent('filterDrawer:productsUpdated'));
  }

  scrollToProducts() {
    const productGrid = document.querySelector('#product-grid, .product-grid, [id*="product-grid"]');
    if (productGrid) {
      const offset = 100;
      const elementPosition = productGrid.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  showLoading() {
    if (this.applyButton) {
      this.applyButton.disabled = true;
      this.applyButton.style.opacity = '0.6';
      this.applyButton.textContent = 'Applying...';
    }

    const productGridContainer = document.querySelector('#ProductGridContainer, [id*="ProductGridContainer"]');
    if (productGridContainer) {
      let loadingOverlay = productGridContainer.querySelector('.loading-overlay');
      if (!loadingOverlay) {
        loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'loading-overlay';
        loadingOverlay.innerHTML = '<div class="loading-spinner"></div>';
        productGridContainer.style.position = 'relative';
        productGridContainer.appendChild(loadingOverlay);
      }
      loadingOverlay.style.display = 'flex';
      loadingOverlay.style.opacity = '1';
    }
  }

  hideLoading() {
    if (this.applyButton) {
      this.applyButton.disabled = false;
      this.applyButton.style.opacity = '1';

      const applyText = this.applyButton.dataset.originalText || 'Apply';
      this.applyButton.textContent = applyText;
    }

    const loadingOverlay = document.querySelector('.loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.opacity = '0';
      setTimeout(() => {
        loadingOverlay.style.display = 'none';
      }, 300);
    }
  }

  trapFocus() {
    if (!this.panel) return;

    const focusableElements = this.panel.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (firstElement) {
      firstElement.focus();
    }

    this.tabHandler = (e) => {
      if (e.key !== 'Tab') return;
      if (!this.classList.contains('active')) return;

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    };

    this.panel.addEventListener('keydown', this.tabHandler);
  }

  disconnectedCallback() {
    if (this.escapeHandler) {
      document.removeEventListener('keydown', this.escapeHandler);
    }
    if (this.tabHandler && this.panel) {
      this.panel.removeEventListener('keydown', this.tabHandler);
    }
  }
}

// Define custom element
if (!customElements.get('filter-drawer')) {
  customElements.define('filter-drawer', FilterDrawer);
}

// Track if already initialized
let filterDrawerInitialized = false;

// Initialize filter drawer
function initFilterDrawer(force = false) {
  if (filterDrawerInitialized && !force) return;

  const triggers = document.querySelectorAll('.filter-drawer-trigger');
  const drawer = document.querySelector('filter-drawer');

  if (!triggers.length || !drawer) return;

  filterDrawerInitialized = true;

  // Setup trigger button(s)
  triggers.forEach((trigger) => {
    const newTrigger = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(newTrigger, trigger);

    newTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.open();
    });
  });

  // Sort dropdown inside drawer - auto-apply on change
  const sortSelect = document.querySelector('#SortBy-drawer');
  if (sortSelect) {
    // Update custom select display text
    const updateSelectDisplay = () => {
      const selectText = document.querySelector('[data-select-text]');
      if (selectText) {
        const selectedOption = sortSelect.options[sortSelect.selectedIndex];
        selectText.textContent = selectedOption.text;
      }
    };

    // Initialize display text
    updateSelectDisplay();

    sortSelect.addEventListener('change', (e) => {
      // Update display text
      updateSelectDisplay();

      // Automatically apply filters when sort changes
      if (drawer && drawer.applyFilters) {
        drawer.applyFilters();
      }
    });
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFilterDrawer());
} else {
  initFilterDrawer();
}

// Backup initialization (only if not already initialized)
setTimeout(() => {
  if (!filterDrawerInitialized) {
    initFilterDrawer();
  }
}, 500);

// Allow re-binding when drawer markup is replaced dynamically
window.refreshFilterDrawerTriggers = function refreshFilterDrawerTriggers() {
  filterDrawerInitialized = false;
  initFilterDrawer(true);
};

// Handle browser back/forward buttons
window.addEventListener('popstate', (e) => {
  const drawer = document.querySelector('filter-drawer');
  if (drawer) {
    drawer.fetchFilteredResults(window.location.href);
  } else {
    window.location.reload();
  }
});

// Handle active filter tags removal
document.addEventListener('click', (e) => {
  if (e.target.closest('.active-filter-tag')) {
    e.preventDefault();
    const tag = e.target.closest('.active-filter-tag');
    const filterParam = tag.dataset.filterParam;
    const filterValue = tag.dataset.filterValue;

    if (filterParam && filterValue) {
      const drawer = document.querySelector('filter-drawer');

      if (drawer) {
        const checkbox = drawer.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);
        if (checkbox) {
          checkbox.checked = false;
        }
        drawer.applyFilters();
      } else {
        const url = new URL(window.location.href);
        const params = url.searchParams.getAll(filterParam);

        url.searchParams.delete(filterParam);
        params.forEach(param => {
          if (param !== filterValue) {
            url.searchParams.append(filterParam, param);
          }
        });

        window.location.href = url.toString();
      }
    }
  }
});
